import { useState, useEffect } from 'react';
import api from '../services/api';
import useCurrentUser from './useCurrentUser';

export default function useAcl() {
    const currentUser = useCurrentUser();
    const [acl, setAcl] = useState(null);
    const [aclLoading, setAclLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            setAclLoading(false);
            return;
        }
        api.get('/acl_configs').then(res => {
            const config = res.data.member?.[0]?.config || {};
            setAcl(config);
        }).catch(err => {
            if (err.response?.status === 401) {
                localStorage.clear();
                window.location.reload();
            }
        }).finally(() => {
            setAclLoading(false);
        });
    }, []);

    const can = (permission) => {
        if (!currentUser || !acl) return false;
        if (currentUser.isSuperAdmin) return true;
        const roles = currentUser.roles || [];
        return roles.some(role => acl[role]?.[permission] === true);
    };

    return { can, acl, aclLoading };
}